"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NoRecords = require("./NoRecords.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoRecords = function NoRecords(_ref) {
  var noRecordsText = _ref.noRecordsText;
  return /*#__PURE__*/_react.default.createElement(_NoRecords.NoRecordsContent, null, noRecordsText);
};

NoRecords.propTypes = {
  /** override for the 'no records' message */
  noRecordsText: _propTypes.default.string
};
NoRecords.defaultProps = {
  noRecordsText: 'No Records Found'
};
var _default = NoRecords;
exports.default = _default;